// This component handles the App template used on every page.
import React from 'react';
import { connect } from 'react-redux';
import SideMenu from './side-menu/sideMenu';
import MenuToggle from './common/menuToggle';


class App extends React.Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      sideMenu: false
    }
    this.toggleSideMenu = this.toggleSideMenu.bind(this);
  }


  toggleSideMenu() {
    this.setState({ sideMenu: !this.state.sideMenu });
  }


  render() {
    return (

      <div>
        <MenuToggle className="menu-toggle" onClick={this.toggleSideMenu} />
        <div className="lower-layout">
          <div className={`${this.state.sideMenu ? '' : 'hide-menu'} sidebar col-md-2 col-sm-2`}>
            <SideMenu location={this.props.location} />
          </div>
          <div className="main-content col-md-10 col-sm-12 col-md-push-2"onClick={(evt) => {if(this.state.sideMenu) this.toggleSideMenu();} }>
            <div className="body-content col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div className="app-content">
                {this.props.children}
              </div>
            </div>
            <div className="clearfix"></div>
          </div>
        </div>
      </div>

    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    loading: state.ajaxCallsInProgress > 0
  };
}

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/components/App.js